export const FEATURE_CODES = {
	TOOL_INTEGRATIONS: 'tool_integrations',
	INCLUDE_ASSIGNEES: 'include_assignees',
	INCLUDE_LABELS: 'include_labels',
	INCLUDE_COMMENTS: 'include_comments',
	CAPTURE_SCREENSHOTS_UNLIMITED: 'capture_screenshots_unlimited',
	SCREEN_RECORDINGS_UNLIMITED: 'screen_recordings_unlimited',
	INSTANT_REPLAY_UNLIMITED: 'instant_replay_unlimited',
	CONSOLE_NETWORK_LOGS: 'console_network_logs',
	E2E_TEST_GENERATOR: 'e2e_test_generator',
	GUEST_REPORTERS_UNLIMITED: 'guest_reporters_unlimited',
	WEB_SDK_CUSTOMISED_UI: 'web_sdk_customised_ui',
	WORKFLOW_AUTOMATION: 'workflow_automation',
	PUBLIC_FOLDERS: 'public_folders',
	PRIVATE_FOLDERS: 'private_folders',
	VIDEO_MARKERS: 'video_markers',
	VOICE_OVER: 'voice_over',
	CAMERA_RECORDING: 'camera_recording',
	PUBLIC_BUG_LINK: 'public_bug_link',
	PRIVATE_BUG_LINK: 'private_bug_link',
	PRIVATE_REPORT_SHARING: 'private_report_sharing',
}
